Vue.component('datatable', {
    props: {
        tableCols: {
            type: Object,            
        },
        tableRows: {
            type: Object,            
        },
        isLoading: {
            type: Boolean
        },
        tableColsKey: {
            type: String
        },
        tableRowKey: {
            type: String
        },
        tableKeyedObject: {
            type: Object
        },
        selectedData: {
            type: Object
        },
        featured: {
            type: Array
        }

    },
    data () {
        return {
            currentSort: 0,
            currentSortDir:'asc'
        }

    },
    computed: {
        sortedRows () {            
            let self = this;
            let order = [];
            let thiskey = 'agency_name';
            let isNumeric = false;
            if (self.tableCols[self.currentSort] && self.tableCols[self.currentSort].data_type && (self.tableCols[self.currentSort].data_type == "Number" || self.tableCols[self.currentSort].data_type == "Calculation")) {
                isNumeric = true;
            }
            if (self.currentSort == 0) {
                order = Object.keys(self.tableKeyedObject).sort( function (keyA, keyB) {
                    if(self.currentSortDir === 'desc') { 
                        if(self.tableKeyedObject[keyB].agency_name > self.tableKeyedObject[keyA].agency_name) { return 1; }
                        else {return -1;}                        
                    }
                    if(self.tableKeyedObject[keyB].agency_name > self.tableKeyedObject[keyA].agency_name) { return -1; }
                    else {return 1;}
                })
            }
            else {
                order = Object.keys(self.tableRows).sort( function(keyA, keyB) {                                                    
                    if (isNumeric) {
                        let thisA = self.tableRows[keyA][self.currentSort];
                        let thisB = self.tableRows[keyB][self.currentSort];
                        
                        if (thisA == "NaN" || thisA == "INF") {thisA = -1;}
                        if (thisB == "NaN" || thisB == "INF") {thisB = -1;}

                        if(self.currentSortDir === 'desc') { return thisB - thisA}
                        return thisA - thisB;    
                    }
                    if(self.currentSortDir === 'desc') {
                        if (self.tableRows[keyA][self.currentSort] > self.tableRows[keyB][self.currentSort]) {return 1;}
                        else {return -1;}                          
                    }
                    if (self.tableRows[keyA][self.currentSort] > self.tableRows[keyB][self.currentSort]) {return -1;}
                    else {return 1;}  
                });
            }            
            let newObj = {};
            order.forEach(item => {
                newObj["'" + item + "'"] = this.tableRows[item];
            }); 
            return newObj;  
        },
        noData () {
            if (this.sortedRows && Object.keys(this.sortedRows).length > 0) {return false;}
            return true;
        }
    },
    mounted () {
        this.setStickyHeaders();
    },
    methods: { 
        getCellData (r, c, j) {        
            // FOR AGENCY
            if (c[this.tableColsKey] == 0) {
                // remove single quote that made string                
                j = j.replace(/'/g,'');
                if (this.tableRowKey == "state") {
                    return j;
                }
                if (this.tableKeyedObject[j]) {
                    return this.tableKeyedObject[j].agency_name
                }
                return ''                
            }

            let field = this.selectedData.selected.filters[this.tableColsKey].filter(item => item[this.tableColsKey] == c[this.tableColsKey]);
            if (field[0] && field[0].data_format) {
                return formatSlideData(r[c.data_field_id], field[0].data_format, field[0]);                
            }            
            return r[c[this.tableColsKey]]
        },
        isActive (c) {
            return c == this.currentSort;
            
        },
        updateSort (s) {
            let triangle = document.getElementById('triangle-'+s);
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
                if (this.currentSortDir == 'desc') {triangle.classList.add('down');}
                else {triangle.classList.remove('down');}
            }
            else {
                this.currentSortDir = 'asc';
                triangle.classList.remove('down');
            
            }
            this.currentSort = s
        },
        exportCSV () {
            let arrayHeader = [];
            let $this = this;
            for (c in this.tableCols) {
                arrayHeader.push(this.tableCols[c].data_name);
            }

            let arrayData = [];
            
            for (r in this.sortedRows) {
                /* FIRST REMOVE EXTRA STRINGS THAT COME IN PLACE DUE TO EARLIER FORMATTING */
                if (r.length && r[0] === "'") {
                    r = r.substring(1);
                }
                if (r.length && r.charAt(r.length-1) == "'") {
                    r = r.slice(0, -1);
                }
                
                let rowData = [];
                for (c in this.tableCols) {
                    rowData.push(this.getCellData($this.tableRows[r], this.tableCols[c], r));
                }     
                arrayData.push(rowData);         
            }
            
            let delimiter = ";";
            let fileName = "SLIDE_Data_File";
            let header = arrayHeader.join(delimiter) + '\n';
            let csv = header;
            arrayData.forEach( array => {
                csv += array.join(delimiter)+"\n";
            });
    
            let csvData = new Blob([csv], { type: 'text/csv' });  
            let csvUrl = URL.createObjectURL(csvData);
    
            let hiddenElement = document.createElement('a');
            hiddenElement.href = csvUrl;
            hiddenElement.target = '_blank';
            hiddenElement.download = fileName + '.csv';
            hiddenElement.click();            
        },
        setStickyHeaders () {
            // TODO: USE INTERSECTION OBSERVER TO SET STICKY IF WE CAN GET STICKY TO WORK
        },
        isFeatured (item) {
            // remove single quotes that were necessary in sorting
            item = item.replace(/\'/g, "") 
            if (this.featured.includes(item)) {                
                return true;
            }
            return false;
        }
    }
})